<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Wtelw3/tc-custom/9781398485495.jpg?1682168952818" alt="This image is the cover for the book Puddlehoppers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Puddlehoppers
      </h1>
      <p class="bookDescription body article font2">
        <p>Have you ever looked in a puddle? I mean, really looked in a puddle? You may be surprised who is in there looking up at you, while you are looking down into it. And what if you fell in the puddle? Imean, really fell in the puddle? Not just splash your wellies in it, but fell through its surface into another world where the puddlehoppers live? And just like there are not nice people in the world, so there are not so nice puddlehoppers. Jules and his Uncle Gideon become involved in an adventure to stop three such puddlehoppers from doing their evil deeds.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terry Endacott
      </h2>
      
      <p class="authorDescription body article">Terry Endacott gained an MA from University of East Anglia. He worked for many years in education before leaving the profession to devote more time to writing, travelling and playing music. His writing genres include imaginative fantasy for both adults and older children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02326e81